export function split(source) {
    var result = [];
    var current = '';
    var splitChars = ['<', '>', '"', '=', ' ', '?', '/', '{', '}', '\n', '.', '[', ']', '(', ')', ':'];
    for (var i = 0; i < source.length; i++) {
        var char = source.charAt(i);
        if (splitChars.indexOf(char) >= 0) {
            result.push(current);
            current = '';
            result.push(char);
            continue;
        }
        current += char;
    }
    return result;
}
